export const UPDATE_USER_PASSWORD = 'UPDATE_USER_PASSWORD';
export const USER_PASSWORD_ERROR = 'USER_PASSWORD_ERROR';
export const LOADING_USER_PASSWORD = 'LOADING_USER_PASSWORD';
